// src/pages/ChangePassword.js
import Header from 'components/Header';
import PasswordInput from 'components/PasswordInput';
import TextInput from 'components/TextInput';
import {useSelector, useDispatch} from 'react-redux';
import {LoadingSpinner} from './../../../components/Icons'
import {setChangePassword, mypageActions, getTalentDetail} from '../../../reducers/talentMypage'
import {ThunkDispatch} from "@reduxjs/toolkit";
import {validateFieldReq, validateEmail, validatePassword} from '../../../utils/validation'
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LogoHeader from "../../../components/LogoHeader";
import CustomButton from '../../../components/CustomButton';
import { useSnackbar } from "notistack";
import CustomToast from "components/CustomToast";
import i18n from 'i18next';

const ChangePassword = ({ onClose, selectedUser, view }:any) =>  {
  const [passwordOld, setPasswordOld] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [isValidated, setValidated] = useState(true);
  const currentUser = useSelector((state: any) => state.currentUser)
  const talentMypage = useSelector((state: any) => state.talentMypage)
  const navigate = useNavigate();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const { errors, isLoading, isChangePwCompleted, isSuccess, success} = talentMypage

  const {first_name,last_name,id} = currentUser.talentInfo
  const [isSubmittedOnce, setIsSubmittedOnce] = useState(false);
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>()
  // Can get right Id
  useEffect(() => {
      if(id){
        const data = {
          id: Number(id),
        }
        dispatch(getTalentDetail(data))
      }
      },[id]);

    const passwordValidation = (pass1: any, pass2: any) => {
      pass1 === pass2 ? setValidated(true) : setValidated(false);
    };
  
  const showToast = (title: string, message: string, variant: string) => {
    enqueueSnackbar("I love snacks.", {
      content: (key) => (<CustomToast title={title} message={message} variant={variant} snackbarKey={key} closeSnackbar={closeSnackbar} />),
    });
  };

  const changePassword = async(event: any) => {
      event.preventDefault()
      
      if (isLoading) return
      const formData = new FormData(event.target);
      const passwordOld = formData.get('passwordOld') as string;
      const password = formData.get('password') as string;
      const passwordConfirm = formData.get('passwordConfirm') as string;
      let errors = {} as any  
      const validatePasswordOld = validateFieldReq(passwordOld, '旧パスワード')
      if (validatePasswordOld != true)
        errors['passwordOld'] = validatePasswordOld     
      const validatePasswordRes = validateFieldReq(password, '新しいパスワード')
      if (validatePasswordRes != true)
        errors['password'] = validatePasswordRes
      const validatePasswordValue = validatePassword(password)
      if (validatePasswordValue != true)
        errors['password'] = validatePasswordValue
      const validatePasswordConfirmRes = validateFieldReq(passwordConfirm, '新しいパスワード（確認用）')
      if (validatePasswordConfirmRes != true)
        errors['passwordConfirm'] = validatePasswordConfirmRes
  
      dispatch(mypageActions.setError(null))
      dispatch(mypageActions.setErrors(errors)) 
      if (Object.keys(errors).length != 0) return    
      if (password != passwordConfirm) {
        dispatch(mypageActions.setErrors({'passwordConfirm': i18n.t('MSG_GLOBAL_INCORRECT_PASSWORD')}))
        return
      }

      const data = {
        requestBody: {
          passwordOld: passwordOld,
          password: password,
          passwordConfirm: passwordConfirm,
        }
      }
      const result =  await dispatch(setChangePassword(data))
      if(result?.payload?.success){
        navigate("/talent/mypage/change-password-complete")
      } 
      if(!result?.payload?.success && result?.payload?.message){
        showToast('', result?.payload?.message, 'error');
      }
    };

  return (
    <div className='static md:fixed md:inset-0 bg-alu-base'>
      <div className='min-w-[24.75rem] static md:absolute md:top-1/2 left-1/2 md:transform md:-translate-x-1/2 md:-translate-y-1/2'>
        <LogoHeader view="talent" page="advanced"></LogoHeader>
        <div className='bg-white md:rounded-2xl md:shadow-lg md:max-w-[21.4378rem] md:m-auto md:min-h-max min-h-screen w-full py-0 md:py-6'>
          <Header title="パスワードの変更"></Header>
          <div className="flex flex-col items-center justify-center mt-[3.125rem] md:mt-4 px-4 md:px-6">
            <form onSubmit={changePassword} className="bg-white w-full" autoComplete="off">
              <TextInput
                readOnly={true}
                id="email"
                name="email"
                placeholder="入力してください"
                value={currentUser?.email}
                hidden={true}
              />
              <div className="mb-4 mt-4">
                <label className="block mb-2 text-sm" htmlFor="passwordOld">
                旧パスワード
                </label>
                <PasswordInput
                  error={(errors['passwordOld'] || "").length > 0}
                  errorText={errors['passwordOld']}
                  id="passwordOld"
                  name="passwordOld"
                  value={passwordOld}
                  onChange={(e: any) => setPasswordOld(e.target.value)}
                  placeholder="入力してください"
                />
              </div>
              <div className="mb-4">
                <label className="block mb-2 text-sm" htmlFor="password">
                新しいパスワード 
                </label>
                <PasswordInput
                  error={(errors['password'] || "").length > 0}
                  errorText={errors['password']}
                  id="password"
                  name="password"
                  value={password}
                  onChange={(e: any) => setPassword(e.target.value)}
                  placeholder="入力してください"
                />
              </div>
              <div className="mb-10">
                <label className="block mb-2 text-sm" htmlFor="passwordConfirm">
                  新しいパスワード（確認用）
                </label>
                <PasswordInput
                  error={(errors['passwordConfirm'] || "").length > 0}
                  errorText={errors['passwordConfirm']}
                  id="passwordConfirm"
                  name="passwordConfirm"
                  value={passwordConfirm}
                  onChange={(e: any) => {
                    const { value } = e.target;
                    setPasswordConfirm(value);
                    if (isSubmittedOnce && password)
                      passwordValidation(password, value);
                  }}
                  placeholder="入力してください"
                />
              </div>

              <CustomButton type="submit" disabled={isLoading} width='full'>
                <p>{isLoading ? "保存中..." : "変更する"}</p>
                {isLoading && (
                  <span><LoadingSpinner /></span>
                )}
              </CustomButton> 
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
